var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "top-section" }, [
    _c(
      "div",
      { staticClass: "top-section__avatar", style: _vm.groupAvatarStyle },
      [
        _vm.group.is_buddy_group
          ? _c("div", { staticClass: "top-section__group-mark buddy-group" })
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "top-section__name" }, [
      _vm._v("\n        " + _vm._s(_vm.group.name) + "\n    "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "top-section__owner-link" }, [
      _vm.group.community
        ? _c("span", [
            _c(
              "strong",
              [
                _c("simple-link", {
                  attrs: { target: _vm.group.community, color: "#fff" },
                }),
              ],
              1
            ),
            _vm._v("\n            Community\n        "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.group.owner
        ? _c("span", [
            _c(
              "strong",
              [
                _c("simple-link", {
                  attrs: { target: _vm.group.owner, color: "#fff" },
                }),
              ],
              1
            ),
            _vm._v("'s Circle\n        "),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.showButtonsPanel
      ? _c(
          "div",
          { staticClass: "top-section__buttons-panel" },
          _vm._l(_vm.buttons, function (button) {
            return _c(
              "router-link",
              {
                key: button.label,
                staticClass: "top-section-button",
                attrs: { to: { ..._vm.$route, name: button.to } },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "top-section-button__container",
                    class: {
                      "top-section-button__container_active":
                        _vm.$route.name === button.to,
                    },
                  },
                  [
                    _c("div", { staticClass: "top-section-button__image" }, [
                      _c("i", {
                        class: button.iconClass,
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "top-section-button__label" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(button.label) +
                          "\n                "
                      ),
                    ]),
                  ]
                ),
              ]
            )
          }),
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }